import { AccordionTableContent } from './accordion-table-content';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import type { ComparisonTableProps } from '../types';

const ComparisonTableMobile = ({ comparisonTable }: ComparisonTableProps) => {
  return (
    <Accordion type="multiple" data-component="ComparisonTable">
      {comparisonTable.data.map((item, index: number) => {
        return (
          <AccordionItem key={`${index}-${item.title}`} value={item.title}>
            <AccordionTrigger>
              <div className="flex flex-col gap-1">
                <span>{item.title}</span>
                <span className="text-black text-sm font-nunito300! pr-16">
                  {item.subtitle}
                </span>
              </div>
            </AccordionTrigger>
            <AccordionContent className="mt-4">
              <AccordionTableContent
                accordionItem={item}
                tableHeadingMobile={comparisonTable.tableHeadingMobile}
              />
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};

export { ComparisonTableMobile };
